import styled from 'styled-components';

import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledShowBookmarksSidebarButton = styled(
  StyledControlBarButton,
)``;
